<template>
	<div class="modal-card" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">{{ title }}</p>
		</header>
		<section class="modal-card-body">
			<div v-html="message"></div>
		</section>
		<footer class="modal-card-foot">
			<o-button variant="success" icon-left="save" @click="Save">{{ saveText }}</o-button>
			<o-button inverted icon-left="undo" @click="Discard">{{ discardText }}</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import store from "@/store";
	import currencyFormat from "@/services/utils/currencyFormat";
	export default {
		props: {
			title: {
				type: String,
				default: ""
			},
			message: {
				type: String,
				default: ""
			},
			discardText: {
				type: String,
				default: "Cancel"
			},
			saveText: {
				type: String,
				default: "Continue"
			}
		},
		emits: ["onDiscard", "onSave"],
		setup(props, context) {
			const Discard = () => {
				context.emit("onDiscard");
				context.emit("close");
			};

			const Save = () => {
				context.emit("onSave");
				context.emit("close");
			};

			return {
				Discard,
				Save
			};
		}
	};
</script>